import axios, { type AxiosResponse } from "axios";
import {
  AccountItemSchema,
  ScanDataBusinessUnitItemSchema,
  ScanDataAltriaRcnItemSchema,
  ScanDataConfigSchema,
  ScanDataAccountItemSchema,
} from "@/schemas/index";
import type {
  AccountItemType,
  ScanDataBusinessUnitItemType,
  ScanDataAltriaRcnItemType,
  ScanDataSetupParamsType,
  NotificationSubscriptionSetupItemType,
  ScanDataConfigType,
  ScanDataAccountItemType,
} from "@/schemas/index";
import env from "@/app/config/env";

export interface ServiceScanDataApi {
  fetchScanDataAltriaRcnItems: () => Promise<ScanDataAltriaRcnItemType[]>;

  fetchScanDataAltriaAccounts: () => Promise<AccountItemType[]>;

  fetchScanDataAltriaBusinessUnits: (
    accountId: NotificationSubscriptionSetupItemType["AccountId"],
  ) => Promise<ScanDataBusinessUnitItemType[]>;

  fetchScanDataConfig: (
    AccountId: NotificationSubscriptionSetupItemType["AccountId"],
    vendorCode: NotificationSubscriptionSetupItemType["VendorId"],
  ) => Promise<ScanDataConfigType>;

  fetchScanDataSetup: (data: ScanDataSetupParamsType) => Promise<void>;

  fetchScanDataAccountData: (
    accountId: AccountItemType["Id"],
  ) => Promise<ScanDataAccountItemType[]>;
}

export const serviceScanDataApi: ServiceScanDataApi = {
  fetchScanDataAltriaRcnItems: () => {
    return axios
      .get(`${env.services.portal}/scandata/altria/rcn`)
      .then((response: AxiosResponse<unknown[]>) => {
        return (
          response?.data?.map((item: unknown) =>
            ScanDataAltriaRcnItemSchema.parse(item),
          ) || []
        );
      });
  },

  fetchScanDataAltriaAccounts: () => {
    return axios
      .get(`${env.services.portal}/scandata/accounts`)
      .then((response: AxiosResponse<unknown[]>) => {
        return (
          response?.data?.map((item: unknown) =>
            AccountItemSchema.parse(item),
          ) || []
        );
      });
  },

  fetchScanDataAltriaBusinessUnits: (accountId) => {
    return axios
      .get(
        `${env.services.portal}/scandata/businessunits?accountId=${accountId}`,
      )
      .then((response: AxiosResponse<unknown[]>) => {
        return (
          response?.data?.map((item: unknown) =>
            ScanDataBusinessUnitItemSchema.parse(item),
          ) || []
        );
      });
  },

  fetchScanDataConfig: (AccountId, vendorCode) => {
    return axios
      .get(
        `${env.services.portal}/scandata/${AccountId}?vendorCode=${vendorCode}`,
      )
      .then((response: AxiosResponse<unknown>) => {
        return ScanDataConfigSchema.parse(response?.data) || {};
      });
  },

  fetchScanDataSetup: (data) => {
    return axios.patch(`${env.services.portal}/scandata`, data);
  },

  fetchScanDataAccountData: (accountId) => {
    return axios
      .get(`${env.services.portal}/scandata/accounts/${accountId}`)
      .then((response: AxiosResponse<unknown[]>) => {
        return (
          response?.data?.map((item: unknown) =>
            ScanDataAccountItemSchema.parse(item),
          ) || []
        );
      });
  },
};
